export default [
    'AT',
    'AU',
    'BE',
    'BG',
    'BR',
    'CN',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'FI',
    'FR',
    'GB',
    'GR',
    'HR',
    'HU',
    'IE',
    'IS',
    'IT',
    'JP',
    'LI',
    'LT',
    'LU',
    'LV',
    'MT',
    'NG',
    'NL',
    'NO',
    'NZ',
    'PL',
    'PT',
    'RO',
    'SE',
    'SG',
    'SI',
    'SK',
    'TH',
    'ZA',
];
